import { render } from "./RightDetail.vue?vue&type=template&id=3fc8301d&scoped=true"
import script from "./RightDetail.vue?vue&type=script&lang=js"
export * from "./RightDetail.vue?vue&type=script&lang=js"

import "./RightDetail.vue?vue&type=style&index=0&id=3fc8301d&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc8301d"]])

export default __exports__